import { useAuth } from 'lib/auth';
import { axios } from 'lib/axios';
import { useNotificationStore } from 'stores/notifications';
import PropTypes from 'prop-types';
import { useMutation } from 'react-query';

export const updateShippingDetails = ({ data }) => {
  return axios.put(`/users/me`, data);
};

export const useUpdateShippingDetails = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();
  const { refetchUser } = useAuth();
  return useMutation({
    onSuccess: () => {
      addNotification({
        type: 'success',
        title: 'Shipping details saved.',
      });
      refetchUser();
    },
    ...config,
    mutationFn: updateShippingDetails,
  });
};
